export const partnersIniValues = {
  clientLogo: "",
  _id: "",
};
